// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_rBIfP clearfix","bg":"index_bg_mu-lV"};